const handleAccordionItemScrollIntoView = () =>{
    document.addEventListener('shown.bs.collapse', ev =>{
        if(!ev.target.closest('.wp-block-ume-intra-accordion-child-block.accordion-item')) return;
        let item = ev.target.closest('.wp-block-ume-intra-accordion-child-block.accordion-item');
        item.scrollIntoView();
    })
}
window.addEventListener('load', () => {
    handleAccordionItemScrollIntoView();
});